import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { InvoiceData } from '../models/invoice-data.interface';
import { BasePdfTemplate } from './base-template';
import { getItemUnitName, getSelectedMappingLines } from './helpers/item-display.helper';

export class MedicalA4Template extends BasePdfTemplate {
    override templateName = 'medical-a4-template';
    override templateVersion = '1.0.0';
    override description = 'A4 Size Medical invoice template';
    override pageSize: 'A4' = 'A4';
    override previewImage = 'assets/sampleoutput/a4-sample.png';

    override generatePdfDefinition(data: InvoiceData): TDocumentDefinitions {
        const storename = JSON.parse(localStorage.getItem('storename') || '{}');
        const businessName = storename?.name || data.businessName || '';
        console.log('data', data);
        const formatDate = this.formatDate.bind(this);

        const items = data.items || [];
        const itemsPerPage = 20;
        const chunks = [];
        for (let i = 0; i < items.length; i += itemsPerPage) {
            const chunk = items.slice(i, i + itemsPerPage);
            // Add a little empty space after the last item
            if (i + itemsPerPage >= items.length) {
                if (chunk.length < itemsPerPage) chunk.push({ isEmpty: true } as any);
            }
            chunks.push(chunk);
        }
        let dateObj = data.createdAt ? new Date(data.createdAt) : new Date();
        if (isNaN(dateObj.getTime())) {
            dateObj = new Date();
        }
        let hours = dateObj.getHours();
        const minutes = dateObj.getMinutes();
        const seconds = dateObj.getSeconds();
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12;

        const strTime = hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0') + ' ' + ampm;

        // const grossAmount = items.reduce((sum, item) => sum + ((item.total || 0)), 0);
        // Free items are excluded from the gross (sales) amount
        const grossAmount = items.reduce((sum, item: any) => Number(item.is_free) === 1 ? sum : sum + ((item.total || 0)), 0);

        // Free items summary (qty + value at original price / MRP)
        let totalFreeQty = 0;
        let totalFreeAmount = 0;
        items.forEach((item: any) => {
            if (Number(item.is_free) === 1) {
                totalFreeQty += Number(item.quantity || 0);
                totalFreeAmount += Number(item.originalprice || item.mrp || 0) * Number(item.quantity || 0);
            }
        });
        const hasFreeItems = totalFreeQty > 0;

        const salesTables: any[] = chunks.map((chunk, index) => ({
            table: {
                headerRows: 1,
                widths: [20, '*', 35, 40, 30, 20, 30, 40, 25, 25, 25, 25, 30, 35],
                body: [
                    [
                        { text: 'S.\nNo', style: 'tableHeader', alignment: 'center', bold: true, fontSize: 8 },
                        { text: 'Description', style: 'tableHeader', alignment: 'left', bold: true, fontSize: 8 },
                        { text: 'HSN\nCode', style: 'tableHeader', alignment: 'center', bold: true, fontSize: 8 },
                        { text: 'Batch\nNo', style: 'tableHeader', alignment: 'center', bold: true, fontSize: 8 },
                        { text: 'EX.DT', style: 'tableHeader', alignment: 'center', bold: true, fontSize: 8 },
                        { text: 'Qty', style: 'tableHeader', alignment: 'center', bold: true, fontSize: 8 },
                        { text: 'M.R.P', style: 'tableHeader', alignment: 'center', bold: true, fontSize: 8 },
                        { text: 'Rate', style: 'tableHeader', alignment: 'center', bold: true, fontSize: 8 },
                        { text: 'Dis\n%', style: 'tableHeader', alignment: 'center', bold: true, fontSize: 8 },
                        { text: 'GST\n%', style: 'tableHeader', alignment: 'center', bold: true, fontSize: 8 },
                        { text: 'SGST', style: 'tableHeader', alignment: 'center', bold: true, fontSize: 8 },
                        { text: 'CGST', style: 'tableHeader', alignment: 'center', bold: true, fontSize: 8 },
                        { text: 'GST', style: 'tableHeader', alignment: 'center', bold: true, fontSize: 8 },
                        { text: 'Amt', style: 'tableHeader', alignment: 'center', bold: true, fontSize: 8 },
                    ],
                    ...chunk.map((item: any, i: number) => {
                       
                        if (item.isEmpty) {
                            return [
                                { text: '', margin: [0, 45, 0, 45] }, { text: '' }, { text: '' }, { text: '' }, { text: '' }, { text: '' }, { text: '' }, { text: '' }, { text: '' }, { text: '' }, { text: '' }, { text: '' }, { text: '' }, { text: '' }
                            ];
                        }
                         console.log(item)
                        const price = item.price || 0;
                        const qty = item.quantity || 0;
                        const baseTotal = price * qty;
                        const gstRate = item.taxPercent || item.taxRate || 0;
                        const gstAmount = item.taxAmount || item.taxamount || 0;
                        const cgst = gstAmount / 2;
                        const sgst = gstAmount / 2;
                        console.log(gstAmount)
                        const discPercent = parseFloat(item.discountPercent || item.discountPercentage || 0) || 0;
                        const discAmt = item.discountamt ?? item.discountAmount ?? (discPercent > 0 ? (baseTotal * discPercent / 100) : (item.discount || 0));
                        const itemAmt = baseTotal + gstAmount - discAmt;

                        const rawExp = item.expDate || item.expiry_date || item.expdate || item.expirydate || item.exp_date || '';
                        let formattedExp = rawExp ? String(rawExp).trim() : '';
                        if (formattedExp.includes('T')) {
                            const datePart = formattedExp.split('T')[0];
                            const parts = datePart.split('-');
                            if (parts.length === 3) {
                                formattedExp = `${parts[1]}/${parts[0].slice(-2)}`;
                            }
                        } else if (formattedExp.includes('-') && formattedExp.split('-').length === 3) {
                            const parts = formattedExp.split('-');
                            formattedExp = `${parts[1]}/${parts[0].slice(-2)}`;
                        }
                        const batchVal =  item.batch || item.batchid  || '';
                        const isFree = Number(item.is_free) === 1;
                        // Unit (Qty column is only 20pt wide, so unit goes in a sub-line under the name)
                        const unitName = getItemUnitName(item);
                        // Selected mapping (variants / parameters) — one per line under the item name
                        const mappingLines = getSelectedMappingLines(item);
                        const nameSubLines: string[] = [
                            ...(unitName ? [`Unit : ${unitName}`] : []),
                            ...mappingLines,
                        ];

                        return [
                            { text: i + 1 + index * itemsPerPage, alignment: 'center', margin: [0, 2, 0, 2], fontSize: 8 },
                            // { text: `${item.name || ''}${Number(item.is_free) === 1 ? ' [FREE]' : ''}`, alignment: 'left', margin: [0, 2, 0, 2], fontSize: 8, bold: true },
                            nameSubLines.length
                                ? {
                                    stack: [
                                        { text: `${item.name || ''}${Number(item.is_free) === 1 ? ' [FREE]' : ''}`, alignment: 'left', fontSize: 8, bold: true },
                                        ...nameSubLines.map((line) => ({ text: line, alignment: 'left', fontSize: 7 })),
                                    ],
                                    margin: [0, 2, 0, 2],
                                }
                                : { text: `${item.name || ''}${Number(item.is_free) === 1 ? ' [FREE]' : ''}`, alignment: 'left', margin: [0, 2, 0, 2], fontSize: 8, bold: true },
                            { text: (item.hsncode || item.hsn || '').toString().substring(0, 6), alignment: 'center', margin: [0, 2, 0, 2], fontSize: 8 },
                            { text: `${batchVal}`, alignment: 'center', margin: [0, 2, 0, 2], fontSize: 8 },
                            { text: `${formattedExp}`, alignment: 'center', margin: [0, 2, 0, 2], fontSize: 8 },
                            { text: `${item.quantity}`, alignment: 'center', margin: [0, 2, 0, 2], bold: true, fontSize: 8 },
                            { text: (item.mrp || 0).toFixed(2), alignment: 'center', margin: [0, 2, 0, 2], fontSize: 8 },
                            { text: price.toFixed(2), alignment: 'center', margin: [0, 2, 0, 2], fontSize: 8 },
                            { text: isFree ? '0%' : `${discPercent}%`, alignment: 'center', margin: [0, 2, 0, 2], fontSize: 8 },
                            { text: isFree ? '0%' : `${gstRate}%`, alignment: 'center', margin: [0, 2, 0, 2], fontSize: 8 },
                            { text: isFree ? 0 : sgst, alignment: 'right', margin: [0, 2, 0, 2], fontSize: 8 },
                            { text: isFree ? 0 : cgst, alignment: 'right', margin: [0, 2, 0, 2], fontSize: 8 },
                            { text: isFree ? '0.00' : gstAmount.toFixed(2), alignment: 'right', margin: [0, 2, 0, 2], fontSize: 8 },
                            { text: Number(item.is_free) === 1 ? '0.00' : itemAmt.toFixed(2), alignment: 'right', margin: [0, 2, 0, 2], fontSize: 8, bold: true },
                        ];
                    }),
                ],
            },
            layout: {
                hLineWidth: (i: number) => (index === 0 && i === 0) ? 0 : 0.5,
                vLineWidth: () => 0.5,
                hLineColor: () => 'black',
                vLineColor: () => 'black',
                paddingLeft: () => 4,
                paddingRight: () => 4,
            },
            margin: [0, 0, 0, 0],
        }));

        return {
            pageSize: 'A4',
            pageMargins: [15, 45, 15, 10],
            defaultStyle: {
                fontSize: 10,
                font: 'Roboto'
            },
            header: function (currentPage: number, pageCount: number) {
                return {
                    columns: [
                        { text: '', width: '*' },
                        { text: 'Invoice', bold: true, fontSize: 14, alignment: 'center', width: 130 },
                        { text: 'Original - Buyer Copy', bold: true, fontSize: 12, alignment: 'right', width: 180 }
                    ],
                    margin: [15, 15, 15, 4]
                };
            },
            content: [
                {
                    table: {
                        widths: ['*', 130, 180],
                        body: [
                            [
                                {
                                    stack: [
                                        { text: `${businessName.toUpperCase()}`, bold: true, fontSize: 11, margin: [0, 0, 0, 2] },
                                        { text: `${data.businessAddress || ''}`, margin: [0, 0, 0, 2], fontSize: 9 },
                                        { text: `Phone : ${data.businessPhone || ''}`, margin: [0, 0, 0, 2], fontSize: 9, bold: true },
                                        { text: `GST NO : ${data.business?.gstin || ''}`, bold: true, fontSize: 9 },
                                        { text: `DL NO : ${data.business?.dl_no || ''}`, bold: true, fontSize: 9 }
                                    ],
                                    margin: [4, 4, 4, 4]
                                },
                                {
                                    stack: [
                                        { text: `Patient Name : ${data.customerName || data.party?.name || ''}`, bold: true, fontSize: 9, margin: [0, 0, 0, 2] },
                                        { text: `Phone : ${data.customerMobile || data.party?.mobile || ''}`, bold: true, fontSize: 9, margin: [0, 0, 0, 2] },
                                        { text: `Dr.Name : ${data.doctorName || ''}`, bold: true, fontSize: 9, margin: [0, 0, 0, 2] },
                                        { text: `GST NO : ${data.customerGSTIN || data.party?.gstin || ''}`, bold: true, fontSize: 9 }
                                    ],
                                    margin: [4, 4, 4, 4]
                                },
                                {
                                    table: {
                                        widths: [50, '*'],
                                        body: [
                                            [{ text: 'Inv No', fontSize: 9, bold: true }, { text: `: ${data.invoiceNumber || '-'}`, fontSize: 9 }],
                                            [{ text: 'Date', fontSize: 9, bold: true }, { text: `: ${formatDate((data.invoiceDate || data.invoicedate || '') as string | Date)}`, fontSize: 9 }],
                                            [{ text: 'Time', fontSize: 9, bold: true }, { text: `: ${strTime || ''}`, fontSize: 9 }],
                                            [{ text: 'Terms', fontSize: 9, bold: true }, { text: `: ${data.paymentMethod || 'credit'}`, fontSize: 9 }]
                                        ]
                                    },
                                    layout: 'noBorders',
                                    margin: [4, 4, 4, 4]
                                }
                            ]
                        ]
                    },
                    layout: {
                        hLineWidth: () => 0.5,
                        vLineWidth: () => 0.5,
                        paddingLeft: () => 0,
                        paddingRight: () => 0,
                        paddingTop: () => 0,
                        paddingBottom: () => 0,
                        hLineColor: () => 'black',
                        vLineColor: () => 'black'
                    },
                    margin: [0, 0, 0, 0]
                },
                ...salesTables,
                {
                    table: {
                        widths: ['*'],
                        body: [
                            [
                                { text: `For Home Delivery call ${data.businessName || ''} - ${data.businessPhone || ''}`, bold: true, fontSize: 10, margin: [4, 4, 4, 4] }
                            ]
                        ]
                    },
                    layout: {
                        hLineWidth: (i) => 0.5,
                        vLineWidth: () => 0.5,
                        hLineColor: () => 'black',
                        vLineColor: () => 'black'
                    },
                    margin: [0, 0, 0, 0]
                },
                {
                    table: {
                        widths: ['*', 200],
                        body: [
                            [
                                {
                                    stack: [
                                        { text: 'Amount in words :', bold: true, fontSize: 10, margin: [4, 4, 0, 8] },
                                        { text: `${this.numberToWords(this.getGrandTotal(data)).toUpperCase()} ONLY`, bold: true, fontSize: 10, margin: [4, 0, 0, 15] },
                                        { text: 'Bank Details', bold: true, fontSize: 14, margin: [4, 0, 0, 10] },
                                        {
                                            columns: [
                                                {
                                                    stack: [
                                                        { text: `Bank Name : ${data.bankDetails?.bankName || ''}`, fontSize: 9, margin: [0, 0, 0, 8] },
                                                        // { text: `Branch Name : ${(data.bankDetails as any)?.branch || (data.bankDetails as any)?.branchName || ''}`, fontSize: 9, margin: [0, 0, 0, 8] },
                                                        { text: `Account No : ${data.bankDetails?.accountNumber || ''}`, fontSize: 9, margin: [0, 0, 0, 8] },
                                                        { text: `IFSC Code : ${data.bankDetails?.ifscCode || ''}`, fontSize: 9, margin: [0, 0, 0, 8] }
                                                    ],
                                                    width: '*'
                                                },
                                                // {
                                                //     stack: [
                                                //         (data.bankDetails as any)?.qrCode
                                                //             ? { image: (data.bankDetails as any).qrCode, width: 75, height: 75, alignment: 'center', margin: [0, 2, 0, 0] }
                                                //             : ((data.bankDetails as any).qrCode || (data.bankDetails as any)?.upiId)
                                                //                 ? { qr: `upi://pay?pa=${(data.bankDetails as any)?.upiId || ''}&pn=${encodeURIComponent(data.businessName || '')}&am=${this.getGrandTotal(data).toFixed(2)}`, fit: 75, alignment: 'center', margin: [0, 2, 0, 0] }
                                                //                 : { qr: `Invoice: ${data.invoiceNumber || ''} | Total: ${this.getGrandTotal(data).toFixed(2)}`, fit: 75, alignment: 'center', margin: [0, 2, 0, 0] }
                                                //     ],
                                                //     width: 100,
                                                //     border: [true, true, true, true]
                                                // }
                                                {
                                                    stack: (() => {
                                                        const qrCode = (data.bankDetails as any)?.qrCode?.trim();
                                                        const upiId = (data.bankDetails as any)?.upiId?.trim();

                                                        const isValidBase64 =
                                                            qrCode && /^data:image\/(png|jpe?g);base64,/.test(qrCode);

                                                        if (isValidBase64) {
                                                            return [{
                                                                image: qrCode,
                                                                width: 75,
                                                                height: 75,
                                                                alignment: 'center',
                                                                margin: [0, 2, 0, 0]
                                                            }];
                                                        }

                                                        if (upiId) {
                                                            return [{
                                                                qr: `upi://pay?pa=${upiId}&pn=${encodeURIComponent(data.businessName || '')}&am=${this.getGrandTotal(data).toFixed(2)}`,
                                                                fit: 75,
                                                                alignment: 'center',
                                                                margin: [0, 2, 0, 0]
                                                            }];
                                                        }

                                                        // Nothing to show
                                                        return [];
                                                    })(),
                                                    width: 100,
                                                    border: [true, true, true, true]
                                                }
                                            ],
                                            margin: [4, 0, 0, 0]
                                        },
                                        { text: 'Declaration:', bold: true, fontSize: 12, margin: [4, 15, 0, 5] },
                                        { text: '1. Goods Once Sold cannot be taken back\nor exchange.', fontSize: 9, margin: [4, 0, 0, 0] }
                                    ],
                                    border: [true, false, true, true]
                                },
                                {
                                    stack: [
                                        {
                                            table: {
                                                widths: ['*', '*'],
                                                body: [
                                                    // Free items summary row (only when free items exist)
                                                    ...(hasFreeItems
                                                        ? [[{ text: `Free Items : ${totalFreeQty}`, fontSize: 9, margin: [4, 4, 4, 4] }, { text: totalFreeAmount.toFixed(2), alignment: 'right', fontSize: 9, margin: [4, 4, 4, 4] }]]
                                                        : []),
                                                    [{ text: 'Sales Value', fontSize: 9, margin: [4, 4, 4, 4] }, { text: grossAmount.toFixed(2), alignment: 'right', fontSize: 9, margin: [4, 4, 4, 4] }],
                                                    [{ text: 'Discount', fontSize: 9, margin: [4, 4, 4, 4] }, { text: (data.overallDiscount || 0).toFixed(2), alignment: 'right', fontSize: 9, margin: [4, 4, 4, 4] }],
                                                    [{ text: 'GST', fontSize: 9, margin: [4, 4, 4, 4] }, { text: ((data.cgst || 0) + (data.sgst || 0)).toFixed(2), alignment: 'right', fontSize: 9, margin: [4, 4, 4, 4] }],
                                                    [{ text: 'CR/DR:', fontSize: 9, margin: [4, 4, 4, 4] }, { text: '', alignment: 'right', fontSize: 9, margin: [4, 4, 4, 4] }],
                                                    [{ text: 'R/Off', fontSize: 9, margin: [4, 4, 4, 4] }, { text: (data.roundOff || data.roundOffAmount || 0).toFixed(2), alignment: 'right', fontSize: 9, margin: [4, 4, 4, 4] }],
                                                    [{ text: 'TCS', fontSize: 9, margin: [4, 4, 4, 4] }, { text: '', alignment: 'right', fontSize: 9, margin: [4, 4, 4, 4] }],
                                                    [{ text: 'NET', fontSize: 10, bold: true, margin: [4, 4, 4, 4] }, { text: data?.grandTotal, alignment: 'right', bold: true, fontSize: 10, margin: [4, 4, 4, 4] }]
                                                ]
                                            },
                                            layout: 'noBorders',
                                            margin: [0, 0, 0, 20]
                                        },
                                        { text: `For ${businessName.toUpperCase()}`, alignment: 'center', bold: true, fontSize: 11, margin: [0, 20, 0, 0] }
                                    ],
                                    border: [false, false, true, true]
                                }
                            ]
                        ]
                    },
                    layout: {
                        hLineWidth: (i) => i === 0 ? 0 : 0.5,
                        vLineWidth: (i) => 0.5,
                        hLineColor: () => 'black',
                        vLineColor: () => 'black'
                    },
                    margin: [0, 0, 0, 10]
                }
            ]
        };
    }

    private getGrandTotal(invoice: InvoiceData): number {
        return (
            (invoice.totalAmount || invoice.grandTotal || 0) -
            (invoice.overallDiscount || 0) -
            (Number(invoice.loyaltyAmount) || 0)
        );
    }

    private numberToWords(num: number): string {
        if (!isFinite(num)) return '';
        const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
        const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

        const convertLessThanThousand = (n: number): string => {
            n = Math.floor(n);
            if (n === 0) return '';
            if (n < 10) return ones[n];
            if (n < 20) return teens[n - 10];
            if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + ones[n % 10] : '');
            const h = Math.floor(n / 100);
            const rem = n % 100;
            return ones[h] + ' Hundred' + (rem !== 0 ? ' ' + convertLessThanThousand(rem) : '');
        };

        let n = Math.floor(Math.abs(num));
        if (n === 0) return 'Zero';

        const parts: string[] = [];

        const crore = Math.floor(n / 10000000);
        if (crore) {
            parts.push(convertLessThanThousand(crore) + ' Crore');
            n = n % 10000000;
        }

        const lakh = Math.floor(n / 100000);
        if (lakh) {
            parts.push(convertLessThanThousand(lakh) + ' Lakh');
            n = n % 100000;
        }

        const thousand = Math.floor(n / 1000);
        if (thousand) {
            parts.push(convertLessThanThousand(thousand) + ' Thousand');
            n = n % 1000;
        }

        if (n) {
            parts.push(convertLessThanThousand(n));
        }

        return parts.join(' ').replace(/\s+/g, ' ').trim();
    }
}
